module.exports = __webpack_public_path__ + "img/featured-1.d86a4214.png";